import {inject, Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {LoginRequestModel} from './models/login-request-model';
import {Observable} from 'rxjs';
import {LoginResponseModel} from './models/login-response-model';
import {UserInfoModel} from '../models/user-info-model';
import {jwtDecode} from 'jwt-decode';
import {DefaultSingleResponse} from '../models/default-single-response';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly apiURL = `${environment.uri}/auth`;
  private readonly _http: HttpClient = inject(HttpClient);

  login(request: LoginRequestModel): Observable<DefaultSingleResponse<LoginResponseModel>> {
    return this._http.post<DefaultSingleResponse<LoginResponseModel>>(`${this.apiURL}/login`, request);
  }

  public getUserInfo(): UserInfoModel | undefined {
    const token = sessionStorage.getItem('token');

    if (!token)
      return undefined;

    return jwtDecode(token) as UserInfoModel;
  }
}
